import { render, staticRenderFns } from "./conflict.vue?vue&type=template&id=04cf5949&scoped=true&"
import script from "./conflict.vue?vue&type=script&lang=ts&"
export * from "./conflict.vue?vue&type=script&lang=ts&"
import style0 from "./conflict.vue?vue&type=style&index=0&id=04cf5949&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cf5949",
  null
  
)

export default component.exports